export const CAMPAIGN_HASH = '#campaign'
export const STUDIO_HASH = '#studio'
export const CREDITS_HASH = '#credits'

export type SitePage = 'campaign' | 'studio' | 'credits'

export function pageForHash(hash: string): SitePage {
  if (hash === STUDIO_HASH) return 'studio'
  if (hash === CREDITS_HASH) return 'credits'
  return 'campaign'
}

export function titleForPage(page: SitePage) {
  if (page === 'studio') return 'Placement Studio · Million Dollar Model X'
  if (page === 'credits') return 'Credits · Million Dollar Model X'
  return 'Million Dollar Model X'
}
